<template>
  <v-row dense no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ pageTitle }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="ProductCategory"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="6">
                <CustomTextField
                  v-model="title"
                  label="Найменування*"
                  class="ma-1"
                  @input="isChanged = true"
                />
              </v-col>
              <v-col cols="6">
                <DecimalEditor
                  v-model="percent"
                  label="Відсоток"
                  class="ma-1"
                  @input="isChanged = true"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card flat text>
            <v-card-title class="pb-0">
              <p class="font-weight-medium headline mb-2 mx-1">
                Продукти
              </p>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="products"
                :items-per-page="5"
                :hide-default-footer="products.length < 11"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <ReferenceTitle
                        :id="item.id"
                        component-name="Product"
                        :title="item.id"
                        class="primary--text"
                      />
                    </td>
                    <td>
                      {{ item.title }}
                    </td>
                    <td>
                      {{ item.article }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card-actions>
            <v-btn
              class="primary-button"
              :disabled="!isValid"
              :loading="loading"
              @click="save"
            >
              Зберегти
            </v-btn>
            <v-btn v-if="!modal" @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DecimalEditor from "@/components/DecimalEditor.vue";
import * as productCategoriesApi from "@/backend/productCategoriesApi.js";

export default {
  components: {
    DecimalEditor,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    title: "",
    percent: 0,
    loading: false,
    isChanged: false,
    products: [],
    headers: [
      { text: "id", align: "left", sortable: false, value: "id" },
      {
        text: "Найменування",
        align: "left",
        sortable: false,
        value: "title",
      },
      { text: "Артикул", align: "left", sortable: false, value: "article" },
    ],
  }),
  computed: {
    isValid() {
      return this.title;
    },
    isNew() {
      return +this.id ? false : true;
    },
    pageTitle() {
      return this.isNew ? "Створення категорії продукту" : "Категорія продукту";
    },
  },
  created() {
    if (+this.id) {
      this.getProductCategory();
      this.getCategoryProducts();
    }
  },
  methods: {
    save() {
      this.loading = true;

      const productCategory = {
        title: this.title,
        percent: this.percent,
      };

      if (!this.isNew) {
        productCategoriesApi
          .updateProductCategory(this.id, productCategory)
          .then(() => {
            this.modal ? this.$emit("close") : this.$router.go(-1);
          })
          .finally(() => {
            this.loading = false;
            this.isChanged = false;
          });
      } else {
        productCategoriesApi
          .createProductCategory(productCategory)
          .then(() => {
            this.$router.go(-1);
          })
          .finally(() => {
            this.loading = false;
            this.isChanged = false;
          });
      }
    },
    async getCategoryProducts() {
      this.products = await productCategoriesApi.getProducts(this.id);
    },
    async getProductCategory() {
      const res = await productCategoriesApi.getProductCategory(this.id);
      this.title = res.title;
      this.percent = res.percent;
    },
  },
};
</script>
